import { AuthInvalidationTypes } from "../components/funnel/types";

export function doesUserHaveAccess(data?: AuthInvalidationTypes) {
  const newAccountResponse = data?.[0];
  const newReleaseResponse = data?.[1];
  // The refetch results are Axios response objects, so we need to access .data
  const newUserData = newAccountResponse?.data?.payload?.results?.user;
  const newReleaseData = newReleaseResponse?.data?.payload?.results;

  const { premium_only } = newReleaseData ?? {};
  const userHasGoldAccess = newUserData?.gold && !premium_only;
  const userHasBuyAccess = newReleaseData?.release_user_purchase;
  return {
    userHasBuyAccess,
    userHasGoldAccess,
    userHasAccess: !!(userHasBuyAccess || userHasGoldAccess),
  };
}
